import * as React from 'react';
import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { ILink } from '../../types/link';
import { Link } from 'react-router-dom';

const CustomerCell = (props: GridCustomCellProps) => {
  if (!props.field) return null;

  const customerLink = props.dataItem.Links.find((x: ILink) => x.Name === 'CustomerProfile');
  return (
    <td {...props.tdProps}>
      {customerLink && <Link
        to={customerLink.Link}
        style={{ color: '#007bff' }}
      >
        {props.dataItem.CustomerNumber}
      </Link>}
    </td>
  );
}

export default React.memo(CustomerCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);
